/**
 * Form defaults and display helpers for adjustment reason create/edit.
 */

import { ADJUSTMENT_REASON_LABEL } from './constants';

export const emptyForm = (country) => ({
  id: null,
  label: ADJUSTMENT_REASON_LABEL,
  description: '',
  country,
  scope: '',
  type: '',
  role_scope: '',
});

/** Maps an API enum value to its Spanish label; falls back to raw value. */
export const getOptionLabel = (options, value) =>
  options.find((option) => option.value === value)?.label || value || '-';

export const buildAdjustmentReasonPayload = (form) => ({
  label: ADJUSTMENT_REASON_LABEL,
  description: form.description,
  country: form.country,
  scope: form.scope,
  type: form.type,
  role_scope: form.role_scope,
});
